import { createStore } from 'satcheljs';
import { ObservableMap } from 'owa-mobx4-adapter';
var defaultLeftNavGroupsStore = {
    myOrgGroups: [],
    withContextMenuGroup: null,
    shouldShowAllGroups: false,
    loadGroupsError: false,
    groupNodeViewStates: new ObservableMap({}),
};
export var getLeftNavGroupsStore = createStore('leftNavGroupsStore', defaultLeftNavGroupsStore);
var leftNavGroupsStore = getLeftNavGroupsStore();
export default leftNavGroupsStore;
//# sourceMappingURL=store.js.map